import { render, staticRenderFns } from "./LoginLayout.vue?vue&type=template&id=64f41dfb"
import script from "./LoginLayout.vue?vue&type=script&lang=js"
export * from "./LoginLayout.vue?vue&type=script&lang=js"
import style0 from "./LoginLayout.vue?vue&type=style&index=0&id=64f41dfb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports